export default __webpack_public_path__ + "static/media/edit.6f7d2533.svg";